import LogoLight from '../assets/logos/logo.png';
import LogoDark from '../assets/logos/logo_dark.png';

export const LOGOS = {
  light: LogoLight,  // Normal (light) tema için logo
  dark: LogoDark,    // Dark tema için logo
};

export default LOGOS;
